const data = {
  data: [
    { idevento: '1', evento: 'EventoGrupo1', mensaje: 'Evento de prueba para grupo 1', fecha: '2023-09-08T08:33:58.000000Z', tipoItem: 'Grupo', idItem: 1 },
    { idevento: '2', evento: 'EventoGrupo2', mensaje: 'Evento de prueba para grupo 2', fecha: '2023-09-08T09:33:58.000000Z', tipoItem: 'Grupo', idItem: 1 },
    { idevento: '3', evento: 'EventoGrupo3', mensaje: 'Evento de prueba para grupo 3', fecha: '2023-09-08T10:33:58.000000Z', tipoItem: 'Grupo', idItem: 1 },
    { idevento: '4', evento: 'EventoGrupo4', mensaje: 'Evento de prueba para grupo 4', fecha: '2023-09-08T08:33:58.000000Z', tipoItem: 'Grupo', idItem: 2 },
    { idevento: '5', evento: 'EventoGrupo5', mensaje: 'Evento de prueba para grupo 5', fecha: '2023-09-08T09:33:58.000000Z', tipoItem: 'Grupo', idItem: 2 },
    { idevento: '6', evento: 'EventoGrupo6', mensaje: 'Evento de prueba para grupo 6', fecha: '2023-09-08T10:33:58.000000Z', tipoItem: 'Grupo', idItem: 2 },
    { idevento: '7', evento: 'EventoGrupo7', mensaje: 'Evento de prueba para grupo 7', fecha: '2023-09-08T08:33:58.000000Z', tipoItem: 'Grupo', idItem: 3 },
    { idevento: '8', evento: 'EventoGrupo8', mensaje: 'Evento de prueba para grupo 8', fecha: '2023-09-08T09:33:58.000000Z', tipoItem: 'Grupo', idItem: 3 },
    { idevento: '9', evento: 'EventoGrupo9', mensaje: 'Evento de prueba para grupo 9', fecha: '2023-09-08T10:33:58.000000Z', tipoItem: 'Grupo', idItem: 3 },
    { idevento: '10', evento: 'EventoGrupo10', mensaje: 'Evento de prueba para grupo 10', fecha: '2023-09-08T10:33:58.000000Z', tipoItem: 'Grupo', idItem: 3 },
  ],
  links: {
    first: 'http://localhost/api/v1/businesses?page=1',
    last: 'http://localhost/api/v1/businesses?page=3',
    prev: null,
    next: 'http://localhost/api/v1/businesses?page=2'
  },
  meta: {
    current_page: 1,
    from: 1,
    last_page: 3,
    links: [
      {
        url: null,
        label: '&laquo; Anterior',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=1',
        label: '1',
        active: true
      },
      {
        url: 'http://localhost/api/v1/businesses?page=2',
        label: '2',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=3',
        label: '3',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=2',
        label: 'Siguiente &raquo;',
        active: false
      }
    ],
    path: 'http://localhost/api/v1/businesses',
    per_page: 20,
    to: 20,
    total: 41,
    search: {}
  }
}

export default data
